// src/components/Admin/MerchantCategoryFormModal.js
"use client";

import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";

const MerchantCategoryFormModal = ({ show, onHide, category, onSuccess }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (category) {
      setTitle(category.title || "");
      setDescription(category.description || "");
    } else {
      setTitle("");
      setDescription("");
    }
  }, [category, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      title,
      description,
    };

    try {
      if (category) {
        await api.patch(`/merchant-categories/${category.id}`, payload);
        toast.success("دسته ویرایش شد");
      } else {
        await api.post("/merchant-categories", payload);
        toast.success("دسته جدید ایجاد شد");
      }

      onSuccess();
      onHide();
    } catch (err) {
      toast.error(err.response?.data?.message || "خطا در ذخیره دسته");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>
            {category ? "ویرایش دسته شغل" : "افزودن دسته شغل"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Form.Group className="mb-3">
            <Form.Label>عنوان دسته</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>توضیحات</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description || ""}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            انصراف
          </Button>

          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "در حال ذخیره..." : "ذخیره"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MerchantCategoryFormModal;
